import React from 'react';
import { useTranslation } from 'react-i18next';
import PollBlock from '../../PollView/components/PollBlock';

const PollsTab = ({ polls }) => {
  const { t } = useTranslation();

  return (
    <div className='row'>
      {polls?.map(item => {
        return (
          <div className='col-6 mb-16' key={item.id}>
            <PollBlock poll={item} />
          </div>
        );
      })}
      {!polls?.length && <p className='col-12 mt-3  text-center text-secondary'>{t('polls_no_result')}</p>}
    </div>
  );
};

export default PollsTab;
